import { Box, Flex, Text } from '@chakra-ui/react';

import type { VoucherStatus } from '../types';

type PillStyle = {
  label: string;
  bg: string;
  dot: string;
};

const PUBLICATION_STATUS_PILL = {
  ACTIVE: { label: 'Terbit', bg: '#ECFDF5', dot: '#22C55E' },
  INACTIVE: { label: 'Tidak Terbit', bg: '#FFF5F5', dot: '#E53E3E' },
  PENDING: { label: 'Proses', bg: '#E6F2FF', dot: '#007AFF' },
  FAILED: { label: 'Gagal Terbit', bg: '#FFF5F5', dot: '#C53030' },
  EXPIRED: { label: 'Kedaluwarsa', bg: '#EDF2F7', dot: '#718096' },
} satisfies Record<VoucherStatus, PillStyle>;

const FALLBACK_PILL: PillStyle = {
  label: '',
  bg: '#EDF2F7',
  dot: '#718096',
};

type VoucherPublicationStatusPillProps = {
  status: VoucherStatus;
};

export function VoucherPublicationStatusPill({
  status,
}: VoucherPublicationStatusPillProps) {
  const style =
    status in PUBLICATION_STATUS_PILL
      ? PUBLICATION_STATUS_PILL[status]
      : { ...FALLBACK_PILL, label: status };

  return (
    <Flex
      data-testid="voucher-list-status"
      display="inline-flex"
      align="center"
      gap={2}
      px={3}
      py={1}
      borderRadius="full"
      bg={style.bg}
    >
      <Box
        boxSize={2}
        borderRadius="full"
        bg={style.dot}
        flexShrink={0}
        aria-hidden
      />
      <Text
        fontSize="sm"
        fontWeight="medium"
        color="#1A202C"
        whiteSpace="nowrap"
      >
        {style.label}
      </Text>
    </Flex>
  );
}
